import * as React from 'react'
import styled from 'styled-components'
import I18n from '../../../../../core/i18n'
import { reservationService } from '../../../../../core/services'
import * as constants from '../../../../../static/constants'
import * as forms from '../../../../../utils/form'
import { Button } from '../../../../atoms'
import { Form } from '../../../../molecules'

interface IProps {
  user: any
  conversationId: any
  note?: string
  addMessage: any
}

const FIELDS_MESSAGE = {
  file: 'file',
  body: 'body',
}

const ChatForm: React.FC<IProps> = ({ user, conversationId, note, addMessage }) => {
  const [messageAttachFile, setMessageAttachFile] = React.useState(null)
  const [messageAttachFileUrl, setMssageAttachFileUrl] = React.useState(null)
  const [isSubmitEnabled, setIsSubmitEnabled] = React.useState(null)
  const [errors, setErrors] = React.useState({})

  const messageBodyRef = React.useRef(null)

  const handleUpdateMessage = React.useCallback(
    (updatedErrors, updatedIsSubmitEnabled) => {
      setErrors(updatedErrors)
      setIsSubmitEnabled(updatedIsSubmitEnabled)
    },
    [errors, isSubmitEnabled]
  )

  const handleSubmitMessage = React.useCallback(
    async (initialValues, values) => {
      const formData = new FormData()

      Object.keys(FIELDS_MESSAGE).forEach(field => {
        if (field === 'file') {
          if (messageAttachFile) {
            formData.append(`message[${field}]`, messageAttachFile)
          }
        } else {
          formData.append(`message[${field}]`, values[field])
        }
      })
      formData.append('message[sender_id]', user.id)
      formData.append('message[conversation_id]', conversationId)

      const { message } = await reservationService.createMessage(formData)
      addMessage(message)

      forms.setNativeValue(messageBodyRef.current, '', false)
      messageBodyRef.current.dispatchEvent(new Event('input', { bubbles: true }))
      // reset message[file]
      setMessageAttachFile(null)
      setMssageAttachFileUrl('')
    },
    [messageAttachFile, conversationId]
  )

  const updateMessageFile = file => {
    const fileReader = new FileReader()

    fileReader.onloadend = () => {
      setMessageAttachFile(file)
      setMssageAttachFileUrl(fileReader.result)
    }
    fileReader.readAsDataURL(file)
  }

  return (
    <Wrapper>
      <ThreadForm>
        <div className="Thread_FormBalloon">
          <Form
            fields={FIELDS_MESSAGE}
            handleSubmit={handleSubmitMessage}
            handleUpdateForm={handleUpdateMessage}
          >
            <div className="Thread_FormHeader">
              <textarea
                required={true}
                placeholder={I18n.t('reservation.input_message')}
                name="body"
                ref={messageBodyRef}
              />
              {messageAttachFileUrl && (
                <ImagePreview>
                  <img src={messageAttachFileUrl} alt="" />
                  <span
                    className="ImagePreview_Delete"
                    onClick={() => {
                      setMessageAttachFile(null)
                      setMssageAttachFileUrl('')
                    }}
                  >
                    <svg
                      xmlns="http://www.w3.org/2000/svg"
                      viewBox="0 0 24 24"
                      aria-hidden="true"
                      role="presentation"
                    >
                      <path d="M19 6.41L17.59 5 12 10.59 6.41 5 5 6.41 10.59 12 5 17.59 6.41 19 12 13.41 17.59 19 19 17.59 13.41 12z" />
                      <path d="M0 0h24v24H0z" fill="none" />
                    </svg>
                  </span>
                </ImagePreview>
              )}
            </div>
            <div className="Thread_FormFooter">
              <Button>
                <label>
                  <input
                    name="file"
                    type="file"
                    accept="image/png, image/jpeg"
                    onChange={event => updateMessageFile(event.currentTarget.files[0])}
                  />
                  {I18n.t('reservation.add_image')}
                </label>
              </Button>
              <Button primary={true} disabled={!isSubmitEnabled}>
                {I18n.t('generic.send')}
              </Button>
            </div>
          </Form>
        </div>
      </ThreadForm>
      {note && <p className="note">{note}</p>}
    </Wrapper>
  )
}

const ImagePreview = styled.div`
  position: relative;
  display: flex;
  justify-content: center;
  height: 120px;
  background-color: rgba(0, 0, 0, 0.75);

  > img {
    height: inherit;
  }

  .ImagePreview_Delete {
    position: absolute;
    top: 4px;
    right: 4px;
    width: 24px;
    height: 24px;
    cursor: pointer;

    > svg {
      fill: ${constants.COLORS.white};
    }
  }
`
const Wrapper = styled.div`
  margin-bottom: 24px;
  padding-bottom: 24px;

  .note {
    margin-top: 10px;
    font-size: 14px;
  }
`
const ThreadForm = styled.div`
  display: flex;

  input[type='file'] {
    display: none;
  }

  textarea {
    width: 100%;
    height: 100px;
    padding: 8px 12px;
    border: none;
  }

  .Thread_FormHeader {
    margin-bottom: 12px;
  }

  .Thread_FormFooter {
    display: flex;
    justify-content: flex-end;
  }

  .Thread_FormBalloon {
    flex: 1;
    padding: 16px;
    border: solid 1px ${constants.COLORS.divider};
    border-radius: 5px;
  }

  .Thread_FormAvator {
    width: 48px;
    height: 48px;
    border-radius: 50%;
    overflow: hidden;

    > img {
      width: inherit;
      height: inherit;
      object-fit: cover;
    }
  }
`

export default ChatForm
